export default __webpack_public_path__ + "static/media/usm.cb869b6c.jpeg";